import DotNetObject = DotNet.DotNetObject;
import { TaskCategory } from '@crimsontide/core/client/interfaces';

export const TaskCategoryService = (() => {
  let dotNetObj: DotNetObject;
  let cachedTaskCategories: TaskCategory[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getTaskCategories = async (useCache: boolean = true): Promise<TaskCategory[]> => {
    if (useCache && cachedTaskCategories != null)
      return cachedTaskCategories;

    if (dotNetObj) {
      cachedTaskCategories = await dotNetObj.invokeMethodAsync<TaskCategory[]>('GetAsync');
      return cachedTaskCategories;
    } else {
      throw 'Task Category DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getTaskCategories,
  };
})();
